import axios from 'axios';
import { musteriToken } from '@/services/useToken';

const isLocalhost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

const API_BASE_URL = isLocalhost
  ? "http://localhost/takip/api/app/"
  : "https://takip.gifadwork.com/api/app/";

const axiosCustomMusteri = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'multipart/form-data'
  },
});

// Request interceptor - her istekte token'ı dinamik olarak ekle
axiosCustomMusteri.interceptors.request.use(
  (config) => {
    if (musteriToken.value) {
      config.headers.Authorization = `Bearer ${musteriToken.value}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - 401 hatası durumunda login sayfasına yönlendir
axiosCustomMusteri.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token geçersiz, müşteri login sayfasına yönlendir
      musteriToken.value = '';
      window.location.href = '/musterilogin';
    }
    return Promise.reject(error);
  }
);

export default axiosCustomMusteri;